const sortByPriorityAndDistance = (a, b) => {
  // Sort by custom_position DESC
  const aPosition = Number(a?.custom_position || '0');
  const bPosition = Number(b?.custom_position || '0');
  if (aPosition !== bPosition) return bPosition - aPosition;

  // If custom_position is equal then sort by distance ASC
  const aDistanceFromUser = Number(a?.distance || 0);
  const bDistanceFromUser = Number(b?.distance || 0);
  return aDistanceFromUser - bDistanceFromUser;
};

export default sortByPriorityAndDistance;
